import { useQuery } from "@tanstack/react-query";
import { Badge, Group, Text } from "@mantine/core";
import { contactApi } from "@/lib/api/contact";

/**
 * Shows the contact group(s) a ticket has been routed to, e.g.
 * "Routed to: Support, IT". Resolves group ids → names via the shared
 * contact-groups query (cached ~5min). Renders nothing when there are no
 * groups (i.e. a pure AI chat that was never escalated).
 */
export function RoutedToBadges({ groupIds }: { groupIds: number[] }) {
  const { data: groups = [] } = useQuery({
    queryKey: ["contact-groups"],
    queryFn: () => contactApi.getContactGroups().then((r) => r.data),
    staleTime: 5 * 60 * 1000,
    enabled: groupIds.length > 0,
  });

  if (groupIds.length === 0) return null;

  const nameById = new Map(groups.map((g) => [g.id, g.name]));

  return (
    <Group gap={6} wrap="wrap" align="center">
      <Text fz="xs" c="dimmed">
        Routed to:
      </Text>
      {groupIds.map((id) => (
        <Badge key={id} size="sm" variant="light">
          {nameById.get(id) ?? `#${id}`}
        </Badge>
      ))}
    </Group>
  );
}
